/**
 * Navigation latérale par rôle — source unique (lot G2).
 * Consommée par les layouts AppLayout (SuperAdmin, Admin, Client, Intervenant).
 */

export const SUPERADMIN_NAV = [
  { to: '/dashboard', icon: '📊', labelKey: 'nav.dashboard', exact: true },
  { to: '/dashboard/clients', icon: '👥', labelKey: 'nav.clients' },
  { to: '/dashboard/interventions', icon: '🔧', labelKey: 'nav.interventions' },
  { to: '/dashboard/intervenants', icon: '👨‍🔧', labelKey: 'nav.intervenants' },
  { to: '/dashboard/rapports', icon: '📋', labelKey: 'nav.reports' },
  { to: '/dashboard/admins', icon: '👨‍💼', labelKey: 'nav.admins' },
  { to: '/dashboard/paramètres', icon: '⚙️', labelKey: 'nav.settings' }
];

export const ADMIN_NAV = [
  { to: '/admin/dashboard', icon: '📊', labelKey: 'nav.dashboard', exact: true },
  { to: '/admin/clients', icon: '👥', labelKey: 'nav.clients' },
  { to: '/admin/interventions', icon: '🔧', labelKey: 'nav.interventions' },
  { to: '/admin/intervenants', icon: '👨‍🔧', labelKey: 'nav.intervenants' },
  { to: '/admin/rapports', icon: '📋', labelKey: 'nav.reports' },
  { to: '/admin/parametres', icon: '⚙️', labelKey: 'nav.settings' }
];

export const CLIENT_NAV = [
  { to: '/client', icon: '📊', labelKey: 'nav.dashboard', exact: true },
  { to: '/client/sites', icon: '📍', labelKey: 'nav.mySites' },
  { to: '/client/equipements', icon: '❄️', labelKey: 'nav.myEquipments' },
  { to: '/client/interventions', icon: '🔧', labelKey: 'nav.myInterventions' },
  { to: '/client/rapports', icon: '📋', labelKey: 'nav.myReports' },
  { to: '/client/profil', icon: '⚙️', labelKey: 'nav.profile' }
];

export const INTERVENANT_NAV = [
  { to: '/intervenant', icon: '📊', labelKey: 'nav.dashboard', exact: true },
  { to: '/intervenant/interventions', icon: '🔧', labelKey: 'nav.myInterventions' },
  { to: '/intervenant/rapports', icon: '📋', labelKey: 'nav.myReports' },
  { to: '/intervenant/disponibilites', icon: '📅', labelKey: 'nav.myAvailability' },
  { to: '/intervenant/parametres', icon: '⚙️', labelKey: 'nav.settings' }
];

export const ROLE_NAV_BY_KEY = {
  superadmin: SUPERADMIN_NAV,
  admin: ADMIN_NAV,
  client: CLIENT_NAV,
  intervenant: INTERVENANT_NAV
};
